import React, { useState, useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from '../components/Header';
import CategoryNav from '../components/CategoryNav';
import MasonryGrid from '../components/MasonryGrid';
import ImageModal from '../components/ImageModal';
import UploadFlyerModal from '../components/UploadFlyerModal';
import ReportModal from '../components/ReportModal';
import supabase from '../supabase/supabase';

export default function Home() {
  const [searchParams] = useSearchParams();
  const [activeCategory, setActiveCategory] = useState("All");
  const [categories, setCategories] = useState(["All"]);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [reportingPost, setReportingPost] = useState(null);

  const searchQuery = searchParams.get('q')?.toLowerCase() || '';

  useEffect(() => {
    fetchCategories();
    fetchPosts();
  }, []);

  const fetchCategories = async () => {
    const { data } = await supabase.from('categories_1715000000').select('*');
    if (data) setCategories(["All", ...data.map(c => c.name)]);
  };

  const fetchPosts = async () => {
    // CRITICAL: Order by vote_count DESC so popular items show first
    const { data } = await supabase
      .from('posts_1715000000')
      .select(`*, categories_1715000000 (name)`)
      .order('vote_count', { ascending: false })
      .order('created_at', { ascending: false });
      
    if (data) setPosts(data);
    setLoading(false);
  };

  const filteredItems = useMemo(() => {
    let filtered = posts;
    if (activeCategory !== "All") {
      filtered = filtered.filter(item => item.categories_1715000000?.name === activeCategory);
    }
    if (searchQuery) {
      filtered = filtered.filter(item => {
        const titleMatch = item.title?.toLowerCase().includes(searchQuery);
        const tagsMatch = item.tags?.some(tag => tag.toLowerCase().includes(searchQuery));
        return titleMatch || tagsMatch;
      });
    }
    return filtered;
  }, [activeCategory, posts, searchQuery]);

  return (
    <div className="min-h-screen bg-retro-cream">
      <Header onOpenUpload={() => setIsUploadModalOpen(true)} />
      
      <div className="sticky top-[72px] bg-retro-cream z-30">
        <CategoryNav 
          categories={categories} 
          activeCategory={activeCategory} 
          setActiveCategory={setActiveCategory} 
        />
      </div>

      <main className="mt-8">
        {loading ? (
          <div className="flex justify-center py-20 text-retro-brown">
            <div className="animate-pulse flex flex-col items-center">
              <div className="w-16 h-16 bg-retro-yellow border-4 border-retro-brown rounded-full mb-4 shadow-retro"></div>
              <span className="font-bold text-xl uppercase tracking-wider">Loading...</span>
            </div>
          </div>
        ) : (
          <MasonryGrid 
            items={filteredItems} 
            onImageClick={setSelectedImage}
            onReport={(p) => { setReportingPost(p); setIsReportModalOpen(true); }}
          />
        )}
      </main>

      <ImageModal isOpen={!!selectedImage} image={selectedImage} onClose={() => setSelectedImage(null)} />
      <UploadFlyerModal isOpen={isUploadModalOpen} onClose={() => setIsUploadModalOpen(false)} />
      <ReportModal isOpen={isReportModalOpen} onClose={() => setIsReportModalOpen(false)} post={reportingPost} />
    </div>
  );
}